import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SegmentedButtonProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';

@Component({
  selector: 'bl-frontend-segmentedbutton',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class BlFrontendSegmentedbuttonComponent extends BlFrontendBaseComponent<SegmentedButtonProps> {
  @Input() buttons: SegmentedButtonProps['buttons'] = [];
  @Input() fullWidth: SegmentedButtonProps['fullWidth'] = false;
  @Input() type: SegmentedButtonProps['type'] = 'button';
  @Input() density: SegmentedButtonProps['density'] = 'regular';

  protected override getComponentName(): string {
    return 'SegmentedButton';
  }

  protected override getProps(): SegmentedButtonProps {
    return {
      buttons: this.buttons,
      fullWidth: this.fullWidth,
      type: this.type,
      density: this.density,
    };
  }
}
